import { createLogic } from "redux-logic"

import { LOAD_CAPABILITIES, LOADED_CAPABILITIES } from "./action_types"

import { dispatchError } from "utilities/dispatch-error"
import { fetchJson } from "utilities/fetch-json"

const loadCapabilities = createLogic({
    type: LOAD_CAPABILITIES,

    async process({ getState }, dispatch, done) {
        const { auth } = getState()
        try {
            dispatch({
                type: LOADED_CAPABILITIES,
                capabilities: await fetchJson("/api/capabilities", {
                    headers: { authorization: `Bearer ${auth.accessToken}` },
                }),
            })
        } catch (err) {
            dispatchError(dispatch, err)
        }
        done()
    },
})

export default [loadCapabilities]
